<template>
    <div class="activities-section">
        <div class="container-fluid">
            <div class="row activities-section-row">
                <div class="col-sm-5 col-xs-12 activites-part">
                    <div class="activities-title">
                        <h3>
                            آخر الأخبار والأنشطة
                        </h3>
                        <div class="loader" v-if="loading">
                            <i class="fa fa-spin fa-circle-o-notch"></i>
                        </div>
                    </div>
                    <activity-div v-for="news_item in news" :key="news_item.id" :news="news_item"></activity-div>
                </div>
                <div class="col-sm-7 col-xs-12 counters-bg">
                    <div class="overlay"></div>
                    <counters></counters>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ActivityDiv from '@/components/home/latest-activity-div';
    import Counters from '@/components/home/counters';

    export default {
        name: 'LatestActivities',

        data: () => ({
            news: [],
            loading: true,
        }),

        mounted() {
            axios.get(apiHost + "/news")
                .then((response) => this.news = response.data.slice(0, 5))
                .finally(() => this.loading = false);
        },

        components: {
            ActivityDiv,
            Counters
        }
    }
</script>
<style lang="scss" scoped>
    @import "src/assets/sass/shared.scss";

    .activities-section {
        background-color: #333;
        .activites-part {
            @include border-right(1px solid rgba(#fff, 0.5), $dir);
            @include padding-right(0px);
            .activities-title {
                text-align: center;

                h3 {
                    color: white;
                }

                .loader {
                    font-size: 25px;
                    color: white;
                }
            }
        }
        .row {
            & > div {
                @include float-left($dir);
            }
        }
        .activities-section-row {
            display: flex;
            @include flex-row-direction($dir);
            flex-wrap: wrap;
        }
        .counters-bg {
            background: url('/src/assets/img/bg_header.jpg') no-repeat center center fixed;
            @include prefixer(background-size, cover, ("moz", "ms", "webkit", "o"));
            position: relative;
            @media(max-width: 767px) {
                width: 100%;
            }
            .overlay {
                width: 100%;
                position: absolute;
                height: 100%;
                top: 0px;
                left: 0px;
                background-color: rgba($main-color, 0.4);

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/home/latest-activities.vue